import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { clientQueryKeys } from "./query-keys";

import { instance } from "@/lib/axios/instance";
import { useAuth } from "@/lib/hooks/useAuth";
import { ClientFiltersResponse } from "@/types/response/ClientFiltersResponse";

type UseClientFiltersParams = {
  tenantId?: string | null;
  search?: string;
};

export function useClientFilters(params: UseClientFiltersParams) {
  const { context } = useAuth();

  return useQuery<ClientFiltersResponse, AxiosError>({
    queryKey: clientQueryKeys.filter(params.tenantId, params.search),
    queryFn: () =>
      instance
        .get(`/api/v2/Clients/Filters`, {
          params: {
            tenantId: params.tenantId || undefined,
            search: params.search,
          },
        })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
    enabled: context === "admin",
  });
}
